var map = {
	"./decidim/avatar-multiuser.png": 65518,
	"./decidim/brands/google.svg": 47842,
	"./decidim/cc-badge.png": 13581,
	"./decidim/decidim-logo.svg": 27100,
	"./decidim/default-avatar.svg": 96909,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 70931,
	"./decidim/icons.svg": 96502,
	"./decidim/pattern.png": 69074,
	"./decidim/placeholder.jpg": 72199,
	"./decidim/vendor/leaflet/layers-2x.png": 80454,
	"./decidim/vendor/leaflet/layers.png": 7135,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 82511,
	"./decidim/vendor/leaflet/marker-icon.png": 80189,
	"./decidim/vendor/leaflet/marker-shadow.png": 7111,
	"./decidim/vendor/social-share-button/delicious.svg": 49338,
	"./decidim/vendor/social-share-button/douban.svg": 64716,
	"./decidim/vendor/social-share-button/email.svg": 68077,
	"./decidim/vendor/social-share-button/facebook.svg": 72621,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 98311,
	"./decidim/vendor/social-share-button/google_plus.svg": 4971,
	"./decidim/vendor/social-share-button/hacker_news.svg": 97330,
	"./decidim/vendor/social-share-button/linkedin.svg": 33206,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 52645,
	"./decidim/vendor/social-share-button/pinterest.svg": 42103,
	"./decidim/vendor/social-share-button/qq.svg": 6229,
	"./decidim/vendor/social-share-button/reddit.svg": 45503,
	"./decidim/vendor/social-share-button/telegram.svg": 92351,
	"./decidim/vendor/social-share-button/tumblr.svg": 81276,
	"./decidim/vendor/social-share-button/twitter.svg": 77262,
	"./decidim/vendor/social-share-button/vkontakte.svg": 93190,
	"./decidim/vendor/social-share-button/wechat.svg": 38019,
	"./decidim/vendor/social-share-button/weibo.svg": 53569,
	"./decidim/vendor/social-share-button/whatsapp.svg": 12882,
	"./decidim/vendor/social-share-button/x.svg": 75533,
	"./decidim/vendor/social-share-button/xing.svg": 20954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38874;